import type { Meta, StoryFn } from '@storybook/react';
import type { EmptyStateDataDisplayProps } from './EmptyStateDataDisplay';

import { EmptyStateDataDisplay } from './EmptyStateDataDisplay';

const codeString = '<EmptyStateDataDisplay label={label} paragraph={paragraph} />';

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Molecules/EmptyStateDataDisplay',
  component: EmptyStateDataDisplay,
  parameters: {
    inspectComponent: EmptyStateDataDisplay,
    codeString: codeString,
  },
} as Meta<EmptyStateDataDisplayProps>;

const Template: StoryFn<EmptyStateDataDisplayProps> = (args) => <EmptyStateDataDisplay {...args} />;

export const EmptyStateDataDisplayExample = Template.bind({});
EmptyStateDataDisplayExample.args = {
  label: 'This is an example info empty state data display label',
  paragraph: 'This is an example info empty state data display paragraph',
};
